<template>
    <v-container fluid class="pa-6">
        <v-row class="mb-4 align-center">
            <v-col cols="12">
                <h1 class="text-h5 font-weight-bold text-primary d-flex align-center">
                    <v-icon class="mr-2" color="primary">mdi-ticket-confirmation</v-icon>
                    Pannello Controllo Ticket ed Assistenza Clienti
                </h1>
                <p class="text-subtitle-2 text-grey-darken-1">Visiona i problemi segnalati dagli utenti e chiudili
                    notifcandoli via mail</p>
            </v-col>
        </v-row>

        <v-card variant="outlined" color="grey-lighten-2" class="bg-white">
            <v-data-table :headers="headers" :items="tickets" :loading="loading" class="elevation-0">
                <template v-slot:[`item.stato`]="{ item }">
                    <v-chip :color="item.stato === 1 ? 'success' : 'warning'" size="small" variant="flat"
                        class="font-weight-bold">
                        {{ item.stato === 1 ? 'RISOLTO' : 'APERTO' }}
                    </v-chip>
                </template>

                <template v-slot:[`item.dataInserimento`]="{ item }">
                    {{ formattaData(item.dataInserimento) }}
                </template>

                <template v-slot:[`item.nomeFileOriginale`]="{ item }">
                    <v-btn v-if="item.nomeFileSalvato" variant="text" color="primary" density="compact"
                        prepend-icon="mdi-download" @click="scaricaFile(item.nomeFileSalvato, item.nomeFileOriginale)">
                        {{ item.nomeFileOriginale }}
                    </v-btn>
                    <span v-else class="text-grey text-caption">Nessuno</span>
                </template>

                <template v-slot:[`item.azioni`]="{ item }">
                    <v-btn icon="mdi-eye" variant="text" color="info" density="comfortable" class="mr-1"
                        @click="apriDettaglio(item)" title="Vedi Dettaglio"></v-btn>
                    <v-btn v-if="item.stato === 0" icon="mdi-check-circle" variant="flat" color="success"
                        density="comfortable" @click="avviaRisoluzione(item)" title="Risolvi e Notifica"></v-btn>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialogDettaglio" max-width="600px">
            <v-card v-if="selectedTicket">
                <v-card-title class="bg-primary text-white py-3">Dettaglio Segnalazione #{{ selectedTicket.ticketID
                    }}</v-card-title>
                <v-card-text class="pt-4">
                    <v-row density="compact">
                        <v-col cols="6"><strong>Utente:</strong> {{ selectedTicket.username }}</v-col>
                        <v-col cols="6"><strong>Email:</strong> {{ selectedTicket.emailUtente }}</v-col>
                        <v-col cols="6"><strong>Cod. Azienda:</strong> {{ selectedTicket.codiceAzienda }}</v-col>
                        <v-col cols="6"><strong>Ragione Sociale:</strong> {{ selectedTicket.ragioneSociale }}</v-col>
                        <v-col cols="12">
                            <hr class="my-2 border-grey-lighten-3" />
                        </v-col>
                        <v-col cols="12"><strong>Tipo:</strong> {{ selectedTicket.tipo }}</v-col>
                        <v-col cols="12"><strong>Oggetto:</strong> {{ selectedTicket.oggetto }}</v-col>
                        <v-col cols="12">
                            <strong>Descrizione:</strong>
                            <div class="pa-3 bg-grey-lighten-4 rounded mt-1 text-body-2" style="white-space: pre-wrap;">
                                {{ selectedTicket.descrizione }}
                            </div>
                        </v-col>
                        <v-col cols="12" v-if="selectedTicket.stato === 1">
                            <strong>Note di Risoluzione:</strong>
                            <div class="pa-3 bg-green-lighten-5 rounded mt-1 text-body-2 text-green-darken-4">
                                {{ selectedTicket.noteRisoluzione }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions><v-spacer /><v-btn color="primary"
                        @click="dialogDettaglio = false">Chiudi</v-btn></v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRisolvi" max-width="500px" persistent>
            <v-card>
                <v-card-title class="bg-success text-white py-3">Risolvi Segnalazione ed Invia Email</v-card-title>
                <v-card-text class="pt-4">
                    <p class="text-body-2 mb-3">Inserisci le azioni correttive apportate. Verranno inviate via mail
                        all'utente.
                    </p>
                    <v-textarea v-model="noteChiusura" label="Note di risoluzione/correzione bug" variant="outlined"
                        rows="4" :rules="[v => !!v || 'Inserisci le note prima di salvare']"></v-textarea>
                </v-card-text>
                <v-card-actions class="pb-3 pr-3">
                    <v-spacer />
                    <v-btn variant="text" @click="dialogRisolvi = false" :disabled="submitting">Annulla</v-btn>
                    <v-btn color="success" variant="flat" @click="confermaRisoluzione" :loading="submitting"
                        :disabled="!noteChiusura.trim()">
                        Conferma e Invia Mail
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { getTicketsAssistenzaAdmin, risolviTicketAssistenzaAdmin, scaricaAllegatoTicketAdmin } from "@/api/comunicazioni/api.assistenza.js";

export default {
    name: "GestioneTicketAssistenza",
    data() {
        return {
            loading: false,
            submitting: false,
            tickets: [],
            dialogDettaglio: false,
            dialogRisolvi: false,
            selectedTicket: null,
            noteChiusura: "",
            headers: [
                { title: "ID", key: "ticketID", width: "70px" },
                { title: "Stato", key: "stato", width: "110px" },
                { title: "Azienda", key: "ragioneSociale" },
                { title: "Segnalatore", key: "username" },
                { title: "Tipo", key: "tipo", width: "120px" },
                { title: "Oggetto", key: "oggetto" },
                { title: "Data Ricezione", key: "dataInserimento", width: "150px" },
                { title: "Allegato", key: "nomeFileOriginale" },
                { title: "Azioni", key: "azioni", sortable: false, width: "120px" }
            ]
        };
    },
    created() {
        this.caricaTickets();
    },
    methods: {
        async caricaTickets() {
            this.loading = true;
            try {
                const response = await getTicketsAssistenzaAdmin();
                this.tickets = response.data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        formattaData(stringDate) {
            if (!stringDate) return "";
            const d = new Date(stringDate);
            return d.toLocaleDateString("it-IT") + " " + d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
        },
        async scaricaFile(nomeFileSalvato, nomeFileOriginale) {
            try {
                const res = await scaricaAllegatoTicketAdmin(nomeFileSalvato);
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", nomeFileOriginale || nomeFileSalvato);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error(error);
                this.$store.commit("app/showMessage", { testo: "Errore durante il download dell'allegato.", tipo: "error" });
            }
        },
        apriDettaglio(ticket) {
            this.selectedTicket = ticket;
            this.dialogDettaglio = true;
        },
        avviaRisoluzione(ticket) {
            this.selectedTicket = ticket;
            this.noteChiusura = "";
            this.dialogRisolvi = true;
        },
        async confermaRisoluzione() {
            if (!this.noteChiusura.trim()) return;
            this.submitting = true;
            try {
                await risolviTicketAssistenzaAdmin(this.selectedTicket.ticketID, {
                    noteRisoluzione: this.noteChiusura
                });
                this.$store.commit("app/showMessage", { testo: "Ticket chiuso e utente notificato con successo.", tipo: "success" });
                this.dialogRisolvi = false;
                this.caricaTickets();
            } catch (error) {
                console.error(error);
            } finally {
                this.submitting = false;
            }
        }
    }
};
</script>